"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const DelayNodeValidation_1 = require("../validations/DelayNodeValidation");
class DelayNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.DELAY };
    if (props.type !== types_1.NODE_TYPES.DELAY)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = { delay: "" };
    if (nodeData) deserializeData = nodeData;
    return deserializeData;
  }
  setTarget(target) {
    this.target = target;
  }
  serialize(uiData) {
    this.setTarget({ delay: uiData.delay });
    return uiData;
  }
  validate() {
    return new DelayNodeValidation_1.DelayNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.DelayNode = DelayNode;
//# sourceMappingURL=DelayNode.js.map
